import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

/**
 * Global banner shown ONLY on the read-only showcase (demo) account, at the very
 * top of every page: "Demo account — sample data, read-only".
 *
 * Why: the demo account browses the whole product (including the platform admin
 * pages) but every value it sees on the admin pages / non-member bands is
 * SAMPLE data served by the server, and nothing can be saved. The banner makes
 * that explicit so nobody mistakes the fixtures for live data. (2026-09-15)
 */
export default function ShowcaseBanner() {
  const { t } = useTranslation();
  const { user } = useAuth();

  if (!user?.is_showcase) return null;

  return (
    <div className="showcase-banner" role="status" aria-live="polite">
      <span className="showcase-banner-badge">{t('showcase.badge')}</span>
      <span>{t('showcase.banner')}</span>
    </div>
  );
}
